import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs';
import { DeregisterKkmFields } from '../../kkm-operations/deregister-kkm/deregister-kkm.model';
import { LanguageService } from '../../../../core/services/language.service';
import { KkmsApiService } from '../../../../core/modules/kkms/kkms-api.service';
import { DeregisterReasonCode, DeregisterReasonLocalizedMessage } from '../../../../core/modules/kkms/kkms.types';

interface UiDeregisterReason {
  id: DeregisterReasonCode;
  name: DeregisterReasonLocalizedMessage;
}

@UntilDestroy()
@Component({
  selector: 'tax-kkm-dereg-form',
  templateUrl: './kkm-dereg-form.component.html',
  styleUrls: ['./kkm-dereg-form.component.sass'],
})

export class KkmDeRegFormComponent implements OnInit {
  @Input() kkmForm?: DeregisterKkmFields;

  @Output() continueProcess: EventEmitter<DeregisterKkmFields> = new EventEmitter<DeregisterKkmFields>();

  delReasons: UiDeregisterReason[] = [];
  isConfirmed = true;

  constructor(
    private router: Router,
    private kkmsApiService: KkmsApiService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.languageService.languageChanges
      .pipe(
        switchMap(() => this.kkmsApiService.fetchDelReasons()),
        untilDestroyed(this),
      )
      .subscribe((response) => {
        this.delReasons = Object.entries(response)
          .reduce<UiDeregisterReason[]>((acc, curr) => {
          acc.push({
            id: curr[0], name: curr[1],
          });
          return acc;
        }, []);
      });
  }

  isFormValid(): boolean {
    return Boolean(this.kkmForm
        && this.kkmForm.kkmInternalName
        && this.kkmForm.kkmModel
        && this.kkmForm.kkmSerialNumber
        && this.kkmForm.kkmYear
        && this.kkmForm.retailPlaceId)
      && this.isConfirmed;
  }

  selectedDelReason(reason: UiDeregisterReason): void {
    if (!this.kkmForm) {
      return;
    }

    this.kkmForm.kkmDelReason = reason.id;
  }

  continue(): void {
    this.continueProcess.emit(this.kkmForm);
  }

  back(): void {
    if (!this.kkmForm) {
      return;
    }

    this.router.navigate([`main/kkms/${this.kkmForm.kkmId}/settings`]);
  }
}
